import {useCallback} from 'react';
import {useIsLargishAndUp} from '~library/hooks/useMatchQuery';

interface AutoScrollParams {
  position?: ScrollLogicalPosition;
  delay?: number;
  noMwScroll?: boolean;
}

const DEFAULT_AUTO_SCROLL_PARAMS: AutoScrollParams = {
  position: 'center',
  delay: 350,
  noMwScroll: false,
};

export const useAutoScrollers = () => {
  const isDesktop = useIsLargishAndUp();

  const scrollElementIntoViewById = useCallback(
    (
      id: string,
      {
        position = DEFAULT_AUTO_SCROLL_PARAMS.position,
        delay = DEFAULT_AUTO_SCROLL_PARAMS.delay,
        noMwScroll = DEFAULT_AUTO_SCROLL_PARAMS.noMwScroll,
      }: AutoScrollParams = DEFAULT_AUTO_SCROLL_PARAMS
    ) => {
      if (noMwScroll && !isDesktop) return;
      requestAnimationFrame(() =>
        setTimeout(() => {
          document.getElementById(id)?.scrollIntoView({behavior: 'smooth', block: position});
        }, delay)
      );
    },
    [isDesktop]
  );

  const scrollEventTitleModuleIntoView = useCallback(
    ({
      position = DEFAULT_AUTO_SCROLL_PARAMS.position,
      delay = DEFAULT_AUTO_SCROLL_PARAMS.delay,
      noMwScroll = DEFAULT_AUTO_SCROLL_PARAMS.noMwScroll,
    }: AutoScrollParams = DEFAULT_AUTO_SCROLL_PARAMS) =>
      scrollElementIntoViewById('event-title-module', {position, delay, noMwScroll}),
    [scrollElementIntoViewById]
  );
  const scrollEventDetailsModuleIntoView = useCallback(
    ({
      position = DEFAULT_AUTO_SCROLL_PARAMS.position,
      delay = DEFAULT_AUTO_SCROLL_PARAMS.delay,
      noMwScroll = DEFAULT_AUTO_SCROLL_PARAMS.noMwScroll,
    }: AutoScrollParams = DEFAULT_AUTO_SCROLL_PARAMS) =>
      scrollElementIntoViewById('event-details-module', {position, delay, noMwScroll}),
    [scrollElementIntoViewById]
  );

  return {
    scrollElementIntoViewById,
    scrollEventTitleModuleIntoView,
    scrollEventDetailsModuleIntoView,
  };
};
